<div class="card-container">
  <div class="column-headings">
    <div class="heading">BALANCE</div>
  </div>
  @for (entityLoan of currentPage().data; track entityLoan) {
    <a class="row">
      <app-entity-loan-card [entityLoan]="entityLoan" (cardClicked)="handleCardClicked($event)"></app-entity-loan-card>
    </a>
  }
</div>
